export default __webpack_public_path__ + "static/media/Escudo.e932ae98.svg";